import { NgModule } from '@angular/core';
import { NoPreloading, PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { environment } from '../environments/environment';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    loadChildren: () => import('@admin/app/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'subscription',
    loadChildren: () => import('@admin/app/subscription/subscription.module').then(m => m.SubscriptionModule)
  },
  {
    path: 'link-shortener',
    loadChildren: () => import('@admin/app/link-shortener/link-shortener.module').then(m => m.LinkShortenerModule)
  },
  {
    path: 'ml',
    loadChildren: () => import('@admin/app/ml/ml.module').then(m => m.MlModule)
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];

/**
 * Main application routing
 */
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: environment.production ? PreloadAllModules : NoPreloading,
      scrollPositionRestoration: 'enabled',
      bindToComponentInputs: true
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
